import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./config/authConfig";
import ChatInterface from "./components/ChatInterface";
import Login from "./components/Login";
import Header from "./components/Header";
import styled from "styled-components";

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const App: React.FC = () => {
  const { instance, accounts } = useMsal();
  const [isAuthenticated, setIsAuthenticated] = useState(accounts.length > 0);

  React.useEffect(() => {
    setIsAuthenticated(accounts.length > 0);
  }, [accounts]);

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  const handleLogout = () => {
    instance.logoutPopup().catch((e) => {
      console.error(e);
    });
  };

  return (
    <AppContainer>
      <Header
        isAuthenticated={isAuthenticated}
        user={accounts[0]}
        onLogin={handleLogin}
        onLogout={handleLogout}
      />
      {isAuthenticated ? <ChatInterface /> : <Login onLogin={handleLogin} />}
    </AppContainer>
  );
};

export default App;
